import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

export interface PackingBoxCustomPrinterType {
  data: {};
  form: {
    namePrinter: string;
  };
}

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
  ],
  templateUrl: './custom-printer.component.html',
})
export class PackingBoxCustomPrinterComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef);
  public readonly data: PackingBoxCustomPrinterType[`data`] =
    inject(MAT_DIALOG_DATA);

  form = new FormGroup({
    namePrinter: new FormControl<string>('', [
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(100),
    ]),
  });

  constructor() {}

  ngOnInit(): void {}

  onSave(): void {
    if (this.form.invalid) {
      return;
    }
    this.dialogRef.close({
      namePrinter: this.form.get('namePrinter').value.toLowerCase().trim(),
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
